import React from 'react'
import ListaProveedores from '../components/ListaProveedores'

const proveedores = () => {
  return (
    <ListaProveedores />
  )
}

export default proveedores